import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import './chart_sentence.component.css';

const ChartSentence = (props) => {
  const { isDiversified, sentence } = props;

  const getSentence = (insight) => {
    if (Array.isArray(insight)) {
      return insight.map((value) => {
        if (Array.isArray(value)) {
          return (
            <React.Fragment key={value.join(', ')}>
              <b>&nbsp;{value.join(', ')}</b>.
              <br />
            </React.Fragment>
          );
        } else {
          return value;
        }
      });
    } else {
      return insight;
    }
  };

  return sentence ? (
    <div className="chart_sentence__cont">
      <FontAwesomeIcon
        icon={faFlag}
        color={isDiversified ? '#1ecd93' : '#ff433d'}
      />
      <div>{getSentence(sentence)}</div>
    </div>
  ) : null;
};

export default ChartSentence;
